import { render, staticRenderFns } from "./DialogoGaleriaImagenes.vue?vue&type=template&id=6621b4bc&scoped=true&"
import script from "./DialogoGaleriaImagenes.vue?vue&type=script&lang=ts&"
export * from "./DialogoGaleriaImagenes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621b4bc",
  null
  
)

export default component.exports